import Vue from 'vue'
import Vuex from 'vuex'
import storage from 'local-storage-fallback'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		theme: {
			primary: '#1d1641',
			secondary: '#1b153d',
			tertiary: '#161131',
			accent: '#73e0f8',
			light: '#e8e5f6',
			success: '#004700',
			error_light: '#fee3e2',
			success_light: '#eaffea',
			dark: false,
		},
		user: null,
		token: null,
		loading: false,
		force_load: false,
		alert: {
			message: null,
			type: null,
			link: null,
			link_label: null,
		},
		alert_colors: {
			danger: 'red',
			warning: 'yellow',
			success: 'green',
		},
	},
	getters: {
		user(state) {
			return state.user
		},
		theme(state) {
			return state.theme
		},
		token(state) {
			return state.token
		},
		loading(state) {
			return state.loading
		},
		alert(state) {
			return state.alert
		},
		force_load(state) {
			return state.force_load
		},
	},
	mutations: {
		// persist store
		hydrate(state) {
			const user = JSON.parse(storage.getItem('user'))
			const token = storage.getItem('token')
			const theme = JSON.parse(storage.getItem('theme'))
			if (token && user) {
				state.user = user
				state.token = token
			}
			if (theme) state.theme = theme
		},
		toggleTheme(state) {
			if (state.theme.dark) {
				state.theme.dark = false
				state.theme.primary = '#1d1641'
				state.theme.secondary = '#1b153d'
				state.theme.tertiary = '#161131'
				state.theme.accent = '#73e0f8'
				state.theme.light = '#e8e5f6'
			} else {
				state.theme.dark = true
				state.theme.primary = '#282828'
				state.theme.secondary = '#222222'
				state.theme.tertiary = 'white'
				state.theme.accent = 'orange'
				state.theme.light = '#e7e7e7'
			}
		},
		setUser(state, data) {
			state.user = data
		},
		setToken(state, data) {
			state.token = data
		},
		isLoading(state, loading = true) {
			state.loading = loading
		},
		setAlert(state, data) {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth',
			})

			let message,
				type = 'error',
				link = null,
				link_label = null

			if (Array.isArray(data)) {
				message = data[0]
				type = data[1]
			} else if (typeof data == 'string') {
				message = data
			} else if (data.data.success == true) {
				message = data.data.message
				type = 'success'
			} else if (data.data.errors) {
				const errors = data.data.errors
				message = errors[Object.keys(errors)[0]][0]
			} else if (data.data.success == false) {
				message = data.data.error
			} else if (
				data.data.message == 'Unauthenticated' &&
				window.href.includes('authenticate') == false
			) {
				message = 'Session expired. Please login again.'
			} else if (data.data.message) {
				message = data.data.message
			} else {
				message = "Oops. We couldn't handle this error"
			}

			if (data.link) {
				link = data.link.link
				link_label = 'Learn more'
				if (data.link.label) link_label = data.link.label
			}
			state.alert = { message, type, link, link_label }
		},
		removeAlert(state) {
			state.alert = {
				message: null,
				type: null,
				link: null,
				link_label: null,
			}
		},
		completeLogin(state, data) {
			state.user = data.user
			state.token = data.access_token
		},
		logout(state) {
			state.user = null
			state.token = null
		},
		forceLoad(state, data = true) {
			state.force_load = data
		},
	},
	actions: {},
	modules: {},
})

store.subscribe((mutation, state) => {
	if (mutation.type == 'completeLogin') {
		storage.setItem('token', state.token)
		storage.setItem('user', JSON.stringify(state.user))
	}
	if (mutation.type == 'setToken') storage.setItem('token', state.token)
	if (mutation.type == 'setUser')
		storage.setItem('user', JSON.stringify(state.user))
	if (mutation.type == 'logout') {
		storage.removeItem('user')
		storage.removeItem('token')
		storage.removeItem('theme')
	}
	if (mutation.type == 'toggleTheme')
		storage.setItem('theme', JSON.stringify(state.theme))
})

export default store
